import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl, 
    Alert
  } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchPayscaleRequest, editPayscaleRequest, createPayscaleGroupRequest } from "../../../api/payscale";
import { areaSelectOptionRequest } from "../../../api/area";
import PayscaleEntriesCard from "components/EntriesCards/PayscaleEntriesCard";
import { payLevelSelectOptionRequest } from "api/payLevel";

class PayscaleForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      resource: {
        level: '',
        basicWage: '',
        ecola: '',
        monthlyWage: '',
        dailyRate: '',
        area: '',
        effectiveDate: '',
        entries: []
      },
      areaSelectOptions: [],
      payLevelSelectOptions: [],
      error: null
    }
  }

  componentDidMount() {
    const { instanceId } = this.props;

    if (instanceId) {
      this.fetchInstance(instanceId);
    }
    

    payLevelSelectOptionRequest(
      result => this.setState({ payLevelSelectOptions: result }),
      error => this.setState({ error: "There was an error" })
    );

    areaSelectOptionRequest(
      result => this.setState({ areaSelectOptions: result }),
      error => this.setState({ error: "There was an error" })
    );
  }

  fetchInstance = (id) => {
      fetchPayscaleRequest(id,
          result => this.setState(prevState => ({
              resource: {
                  ...prevState.resource,
                  ...result,
                  entries: [
                    {
                      ...prevState.resource,
                      ...result
                    }
                  ]
              }
          })), error => this.setState({ error: 'There was an error' }));
  }

  handleFormChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [name]: value,
      },
    }))
  }

  onChangeDate = (date, field) => {
    let value = moment(date).format("YYYY-MM-DD");

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [field]: value
      }
    }));
  };

  save = () => {
    const {
      level,
      basicWage,
      ecola,
      monthlyWage,
      dailyRate,
      area,
      effectiveDate,
      entries
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    if (isNewRecord) {

      let data = {
        entries: entries.map(entry => ({ ...entry, effectiveDate })),
        effectiveDate,
        area
      };

      createPayscaleGroupRequest(data,
          result => this.saveSuccess(),
          error => this.saveFailure(error)
      );
    } else {

      let data = {
        level,
        basicWage,
        ecola,
        monthlyWage,
        dailyRate,
        area,
        effectiveDate
      };

        editPayscaleRequest(instanceId, data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    }
  }

  handleGoToList = () => {
    const { effectiveDate, area } = this.state.resource
    this.props.goToList('payscale', `${moment(effectiveDate).format('YYYY/MM/DD')}`, area.toString());
  }

  saveSuccess = () => {
    const {
      instanceId
    } = this.props;

    this.setState({ error: null });
    this.handleGoToList()
  }

  saveFailure = (error) => {
      this.setState({ error: error.message || 'There was an error saving Payscale.' })
  }

  onUpdateEntry = (entry, index) => {
    const {
      instanceId
    } = this.props;

    const { entries } = this.state.resource;
    let updatedEntries = [...entries];
		updatedEntries[index] = {
			...updatedEntries[index],
			...entry
		}
    if(instanceId) {
      this.setState((prevState) => ({
        resource: {
          ...prevState.resource,
          entries: updatedEntries,
          ...updatedEntries[index]
        }
      }));
    } else {
      this.setState((prevState) => ({
        resource: {
          ...prevState.resource,
          entries: updatedEntries
        }
      }));
    }
  }

  addEntry = () => {
    const updatedEntries = [...this.state.resource.entries];
    updatedEntries.push({
      salaryFrom: '',
      salaryTo: '',
      employerShare: '',
      employeeShare: '',
      totalContribution: '',
      isPercentage: false,
      percentageValue: 0
    });
    this.setState((prevState) => ({
      resource: {
        ...prevState.resource,
        entries: updatedEntries
      }
    }));
  }

  deleteEntry = (index) => {
    const { entries } = this.state.resource;
    const updatedEntries = [...entries];
    updatedEntries.splice(index, 1);
    this.setState((prevState) => ({
      resource: {
        ...prevState.resource,
        entries: updatedEntries
      }
    }))
  }

  render() {

    const {
      entries,
      area
    } = this.state.resource;

    const {
      areaSelectOptions,
      payLevelSelectOptions,
      error
    } = this.state;

    const effectiveDate = this.state.resource.effectiveDate ? moment(this.state.resource.effectiveDate, 'YYYY-MM-DD').toDate() : '';

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;
    
    if(isNewRecord) {
      return (
        <Row>
          <Col md={12}>
            <Card
              title={isNewRecord ? "New entry" : "Edit entry"}
              content={
                <form>
                  <Button className="card-top-btn btn-primary" onClick={() => this.props.goBack()}>
                    Back to List
                  </Button>                
                  <FormGroup>
                    <ControlLabel>Area <span className="required-star">*</span></ControlLabel>
                    <FormControl 
                        onChange={this.handleFormChange}
                        componentClass="select" 
                        name="area"
                        value={area}
                      >
                      <option value="">Select</option>
                      {areaSelectOptions.map(option => {
                        return (
                          <option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        );
                      })}
                    </FormControl>
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Effective Date</ControlLabel>
                    <DatePicker
                      selected={effectiveDate}
                      onChange={(date) => this.onChangeDate(date,'effectiveDate')}
                      dateFormat="MM/dd/yyyy"
                      className="dateInput"
                      dropdownMode="select"
                      showYearDropdown
                    />
                  </FormGroup>
                  <div>
                    <div className="add-rule-container">
                      <p className="category">Entries <span className="required-star">*</span></p>
                      <Button className="pull-right" bsStyle="primary" bsSize="sm" onClick={this.addEntry}>Add Entry</Button>
                    </div>
                    {
                      entries.map((entry, index) => {
                        return (
                          <PayscaleEntriesCard payLevelOptions={payLevelSelectOptions} key={index} onUpdateEntry={this.onUpdateEntry} index={index} deleteEntry={this.deleteEntry} entry={entry} />  
                        )
                      })
                    }
                  </div>
                  {error &&
                    <Alert bsStyle="danger">
                      {error}
                    </Alert>
                  }
                  <Button bsStyle="primary" pullRight fill onClick={this.save}>
                    {isNewRecord ? "Create" : "Save changes"}
                  </Button>
                  <div className="clearfix" />
                </form>
              }
            />
          </Col>
        </Row>
      )
    } else {
        return (
          <Row>
            <Col md={12}>
              <Card
                title="Edit Entry"
                content={
                  <form>
                    <Button className="card-top-btn btn-primary" onClick={() => this.props.goBack()}>
                      Back to List
                    </Button>
                    <div className="clearfix" />
                    <PayscaleEntriesCard payLevelOptions={payLevelSelectOptions} onUpdateEntry={this.onUpdateEntry} index={0} deleteEntry={this.deleteEntry} entry={entries[0]} />  
                    <Button bsStyle="primary" pullRight fill onClick={this.save}>
                      Save changes
                    </Button>
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        )
    }
  }
}

export default PayscaleForm;
